const FormResources = {

    form_data:{
        task_id:                '',
        building_id:            '',
        level_id:               '',
        area_id:                '',
        frequency:              '',
        new_task_id:            '',
        new_frequency:          '',
        rooms_id:               [],
        hours_work_week:        40,
    },

    search_form_data:{
        building_id:    '',
        level_id:       '',
        area_id:        '',
        // room_id:        [],
    },
    
    form_format:[
        {
            css_class:  'col-md-2 col-sm-3 forecaster__select__item',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Find rooms with this task:',
            model_name: 'actual_task_id',
            ref:        'actual_task_id_input',
            ref_alt:    'actual_task_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-2 forecaster__select__item',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Frequency old:',
            model_name: 'actual_frequency',
            ref:        'actual_frequency_input',
            ref_alt:    'actual_frequency_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-2 forecaster__select__item',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Modify to use this task:',
            model_name: 'new_task_id',
            ref:        'new_task_id_input',
            ref_alt:    'new_task_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-2 forecaster__select__item',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Frequency new:',
            model_name: 'new_frequency',
            ref:        'new_frequency_input',
            ref_alt:    'new_frequency_input_alt',
            required:   false,
        },
    ],
    
    search_form_format:[
        {
            css_class:  'col-md-6 forecaster__select__item',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Building:',
            model_name: 'building_id',
            ref:        'building_id_input',
            ref_alt:    'building_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6 forecaster__select__item',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Level:',
            model_name: 'level_id',
            ref:        'level_id_input',
            ref_alt:    'level_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6 forecaster__select__item',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Area:',
            model_name: 'area_id',
            ref:        'area_id_input',
            ref_alt:    'area_id_input_alt',
            required:   true,
        },
    ]

}

export default FormResources